import { createFileRoute } from '@tanstack/react-router';
import { SpaceHome } from '@/components/home/SpaceHome';

export const Route = createFileRoute('/$spaceSlug/')({
  component: SpaceHome,
  head: () => ({
    meta: [
      {
        title: 'Findya | Home',
      },
    ],
  }),
});
